type LocalService = {
  // Toggle local service
  enabled: boolean;
  // The Integration environment path that will be filtered for this service
  prefix: string;
  // The target URL for the service (typically localhost:xxxx/api)
  target: string;
};

type LocalServices = Record<string, LocalService>;

export const INTEGRATION_BASE_URL = 'https://apigw.integration.resurs.com';

export const localServices: LocalServices = {
  bill_service: {
    enabled: false,
    prefix: '/api/bill_service',
    target: 'http://localhost:8080/api',
  },
  customer_payment_service: {
    enabled: false,
    prefix: '/api/customer_payment_service',
    target: 'http://localhost:8081/api',
  },
  // Add more services as needed
  // another_service: {
  //   enabled: false,
  //   prefix: '/api/payment_service',
  //   target: 'http://localhost:8081',
  // },
};
